export const roundToOne = (num) => {
  return +(Math.round(num + "e+1") + "e-1");
};

export const getPercentage = (num1, num2, decimalPlaces = 2) => {
  const power = Math.pow(10, decimalPlaces);
  const percentage = (num1 / num2) * 100;
  const roundedPercentage = Math.round(percentage * power) / power;
  return roundedPercentage;
};
